import { Button } from '@mui/material';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import {
  activateDemoSession,
  getDemoLoginPath,
  getDemoLoginUrl,
  isExternalDemoLogin,
  isLiveDemoEntryEnabled,
} from 'utils/demoEnvironment';

/** Demo entry from marketing pages — same origin or demo.mobeat.io when configured. */
export default function TryLiveDemoButton({ size = 'medium', variant = 'outlined', sx, ...props }) {
  if (!isLiveDemoEntryEnabled()) {
    return null;
  }

  const external = isExternalDemoLogin();

  if (external) {
    return (
      <Button
        size={size}
        variant={variant}
        component='a'
        href={getDemoLoginUrl()}
        sx={{ whiteSpace: 'nowrap', ...sx }}
        {...props}
      >
        Try live demo
      </Button>
    );
  }

  return (
    <Button
      size={size}
      variant={variant}
      component={RouterLink}
      to={getDemoLoginPath()}
      onClick={activateDemoSession}
      sx={{ whiteSpace: 'nowrap', ...sx }}
      {...props}
    >
      Try live demo
    </Button>
  );
}

TryLiveDemoButton.propTypes = {
  size: PropTypes.string,
  variant: PropTypes.string,
  sx: PropTypes.object,
};
